import { render, staticRenderFns } from "./Terminate.vue?vue&type=template&id=5bebbd64&scoped=true&lang=pug"
import script from "./Terminate.vue?vue&type=script&lang=ts"
export * from "./Terminate.vue?vue&type=script&lang=ts"
import style0 from "./Terminate.vue?vue&type=style&index=0&id=5bebbd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebbd64",
  null
  
)

export default component.exports